import * as Yup from 'yup'

export const createSumScoredQuestionnaireSchema = (prefix: string, questionCount: number, maxAnswerValue: number) => {
  const questionSchema = Yup.number().required().min(0).max(maxAnswerValue)
  const shape = Object.fromEntries(
    Array.from({ length: questionCount }, (_unused, index) => [`${prefix}_QUESTION_${index + 1}`, questionSchema])
  )
  shape[`${prefix}_SCORE`] = Yup.number()
    .required()
    .min(0)
    .max(questionCount * maxAnswerValue)

  return Yup.object().shape(shape).default({}).required()
}
